<template>
	<div class="leftres">
		<div>
			<div :class="showorhide ? 'inputtop' : 'inputtops'">
				<div style="display: inline-block;" v-for="(item, index) of formdata" :key="index">
					<Commondropdownlist ref="U8invRef" :options="item.options" :minrigth="item.minrigth"
						:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
						:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width" :event="item.event"
						@level1Chage="level1Chage" @level2Chage="level2Chage" @level3Chage="level3Chage">
					</Commondropdownlist>
				</div>
				<div :class="showorhide ? 'Btngroups' : 'Btngroup'">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;"></div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<U9SRReporttable :tableData="tableData" :total="total" @Export="Export"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</U9SRReporttable>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from "../../../components/common-dropdownlist.vue";
	import CommonBtngroup from "../../../components/commongroup.vue";
	import Dialog from "../../../components/dialog.vue";
	import U9SRReporttable from "./components/U9SRReporttable.vue";
	import utils from "../../../common/utils";
	import {
		U8ReportU8SRReportList,
		U8ReportU8SRReportExport,
		HelperU9AccId,
		HelperU9Status,
	} from "@/api/home";

	import {
		GetHelperLevel1,
		GetHelperLevel2,
		GetHelperLevel3,
	} from "@/api/newsapi";
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			U9SRReporttable,
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: "",
						title: "账套号",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "220px",
						options: [],
					},
					{
						inputdata: "",
						title: "经销商",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "210px",
					},
					{
						inputdata: "",
						title: "发货日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
					},
					{
						inputdata: "",
						title: "发货单号",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "210px",
					},
					{
						inputdata: "",
						title: "产品",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "210px",
					},
					{
						inputdata: "",
						title: "LEVEL1",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "selectMultiple",
						width: "220px",
						options: [],
						event: "level1Chage",
					},
					{
						inputdata: "",
						title: "LEVEL2",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "220px",
						options: [],
						event: "level2Chage",
					},
					{
						inputdata: "",
						title: "LEVEL3",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "220px",
						options: [],
						event: "level3Chage",
					},
					{
						inputdata: "",
						title: "产品批号",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "210px",
					},
					{
						inputdata: "",
						title: "经销商类型",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "220px",
						options: [{
								key: "1",
								value: "一级经销商",
							},
							{
								key: "2",
								value: "二级经销商",
							},
						],
						event: "gradeChage",
					},
					{
						inputdata: [],
						title: "状态",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "selectMultiple",
						width: "220px",
						options: [],
					}
				],
				from: {
					cAccId: "",
					cDLCode: "",
					customer: "",
					inventory: "",
					dDate1: "",
					dDate2: "",
					LEVEL1: "",
					LEVEL2: "",
					LEVEL3: "",
					Batch: "",
					Status: "",
				},
			};
		},
		mounted() {
			this.$message.warning("请填写搜索条件！");
			this.$refs.U8invRef[2].startTime = this.$utils.getFYearDate();
			this.HelperU9AccId();
			this.HelperU9Status();
			this.getHelperLevel1();
		},
		methods: {
			level1Chage(e) {
				this.from.LEVEL1 = e.modelvalue.join(',');
				this.getHelperLevel2();
			},
			level2Chage(e) {
				this.from.LEVEL2 = e.modelvalue;
				this.getHelperLevel3();
			},
			level3Chage(e) {
				this.from.LEVEL3 = e.modelvalue;
			},
			//获取l1数据
			async getHelperLevel1() {
				let {
					code,
					data
				} = await GetHelperLevel1({});
				if (code == 0) {
					this.formdata[5].options = [{
						key: "不限",
						value: "",
					}, ];
					this.formdata[6].options = [];
					this.formdata[7].options = [];
					data.map((item, index) => {
						this.formdata[5].options.push({
							key: item.value,
							value: item.key,
						});
					});
				}
			},
			//获取l2数据
			async getHelperLevel2() {
				let {
					code,
					data
				} = await GetHelperLevel2({
					LEVEL1: this.from.LEVEL1,
				});
				if (code == 0) {
					this.formdata[6].options = [];
					this.formdata[7].options = [];
					data.map((item, index) => {
						this.formdata[6].options.push({
							key: item.value,
							value: item.key,
						});
					});
				}
			},
			//获取l3数据
			async getHelperLevel3() {
				let {
					code,
					data
				} = await GetHelperLevel3({
					LEVEL1: this.from.LEVEL1,
					LEVEL2: this.from.LEVEL2,
				});
				if (code == 0) {
					this.formdata[7].options = [];
					data.map((item, index) => {
						this.formdata[7].options.push({
							key: item.value,
							value: item.key,
						});
					});
				}
			},
			// 列表
			async u8ReportU8SRReportList() {
				const loading = this.$loading({
					lock: true,
					text: "正在加载列表...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)",
				});

				let {
					data,
					code
				} = await U8ReportU8SRReportList({
					cAccId: this.from.cAccId || this.formdata[0].options[0].key,
					cDLCode: this.from.cDLCode,
					customer: this.from.customer,
					inventory: this.from.inventory,
					dDate1: this.from.dDate1,
					dDate2: this.from.dDate2,
					LEVEL1: this.from.LEVEL1,
					LEVEL2: this.from.LEVEL2,
					LEVEL3: this.from.LEVEL3,
					Batch: this.from.Batch,
					CusGrade: this.from.CusGrade,
					Status: this.from.Status,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				if (code == 0) {
					this.total = data.Count;
					if (data.data) {
						data.data.forEach(item => {
							if (item.ReturnDate) item.ReturnDate = item.ReturnDate.split(' ')[0];
							if (item.ExpiryDate) item.ExpiryDate = item.ExpiryDate.split(' ')[0];
							if (item.ShipmentDate) item.ShipmentDate = item.ShipmentDate.split(' ')[0];
						});
						this.tableData = data.data;
					}
					loading.close();
				}
				loading.close();
			},
			// 获取账套号下拉
			async HelperU9AccId() {
				let {
					code,
					data
				} = await HelperU9AccId({});
				if (code == 0) {
					try {
						this.formdata[0].options = [];
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text,
							};
							this.formdata[0].options.push(obj);
						});
						this.$refs.U8invRef[0].modelvalue = this.formdata[0].options[0].key;
						//this.u8ReportU8SRReportList()
					} catch (error) {}
				}
			},
			// 获取状态下拉
			async HelperU9Status() {
				let {
					code,
					data
				} = await HelperU9Status({})
				if (code == 0) {
					try {
						this.formdata[10].options = []
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text
							}
							this.formdata[10].options.push(obj)
						})
					} catch (error) {}
				}
			},
			// 导出
			async u8ReportU8SRReportExport() {
				const loading = this.$loading({
					lock: true,
					text: "正在导出...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)",
				});
				let resexprot = await U8ReportU8SRReportExport({
					cAccId: this.from.cAccId || this.formdata[0].options[0].key,
					cDLCode: this.from.cSOCode,
					customer: this.from.customer,
					inventory: this.from.inventory,
					dDate1: this.from.dDate1,
					dDate2: this.from.dDate2,
					LEVEL1: this.from.LEVEL1,
					LEVEL2: this.from.LEVEL2,
					LEVEL3: this.from.LEVEL3,
					Batch: this.from.Batch,
					CusGrade: this.from.CusGrade,
					Status: this.from.Status,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				if (resexprot) {
					let date = new Date();
					let str = `${date.getFullYear()}-${date.getMonth() +
          1}-${date.getDate()}-${date.getTime()}`;
					utils.downloadFile(resexprot, `U8_U9销售退回报表${str}`, "xlsx");
					loading.close();
				} else {
					// 返回json
					this.$message.warning("导出失败");
					loading.close();
				}
				loading.close();
			},
			// 导出
			Export() {
				this.u8ReportU8SRReportExport();
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex;
				this.u8ReportU8SRReportList();
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie;
				this.u8ReportU8SRReportList();
			},
			reset() {
				this.$refs.U8invRef.map((item, index) => {
					if (index == 2) {
						item.startTime = "";
						item.endTime = "";
					} else if (index == 10) {
						item.modelvalue = []
					} else {
						item.modelvalue = "";
					}
				});
			},
			cancel() {
				//console.log('name')
				this.dialogVisibles = false;
			},
			dialogOK() {
				//console.log('name2')
				this.dialogVisibles = false;
			},

			hide() {
				this.showorhide = false;
			},

			select() {
				this.pageindex = 1;
				try {
					this.from.cAccId = this.$refs.U8invRef[0].modelvalue;
					this.from.cDLCode = this.$refs.U8invRef[3].modelvalue;
					this.from.customer = this.$refs.U8invRef[1].modelvalue;
					this.from.inventory = this.$refs.U8invRef[4].modelvalue;
					this.from.Batch = this.$refs.U8invRef[8].modelvalue;
					this.from.dDate1 = this.$refs.U8invRef[2].startTime;
					this.from.dDate2 = this.$refs.U8invRef[2].endTime;
					this.from.CusGrade = this.$refs.U8invRef[9].modelvalue;
					if (this.$refs.U8invRef[10].modelvalue) {
						this.from.Status = this.$refs.U8invRef[10].modelvalue.join(',')
					} else {
						this.from.Status = ''
					}
					this.u8ReportU8SRReportList();
				} catch (error) {
					this.u8ReportU8SRReportList();
				}
			},
			showclick() {
				this.showorhide = true;
			},
		},
	};
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 100px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 310px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 95px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>